var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117 608.4v178.5c1.5 93.7 155.7 169.5 395 169.5s393.4-75.8 395-169.5V608.4H117z",
    fill: "#1B9BDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M907 607.7c0 99.4-154.8 180-395 180s-395-80.6-395-180 154.8-180 395-180 395 80.5 395 180z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117 428.4v158.5c1.5 93.7 155.7 179.5 395 179.5s393.4-85.8 395-179.5V428.4H117z",
    fill: "#1B9BDB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M907 427.7c0 99.4-154.8 180-395 180s-395-80.6-395-180 154.8-180 395-180 395 80.5 395 180z",
    fill: "#FFFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117 248.4v158.5c1.5 93.7 155.7 179.5 395 179.5s393.4-85.8 395-179.5V248.4H117z",
    fill: "#1B9BDB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M907 247.7c0 99.4-154.8 180-395 180s-395-80.6-395-180 154.8-180 395-180 395 80.5 395 180z",
    fill: "#3ED6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDb);
export default __webpack_public_path__ + "static/media/db.25dc6c2bd67540a809a8dddf8b358cef.svg";
export { ForwardRef as ReactComponent };